
import Vue from "vue";
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import AppLanguageSelect from "@/components/CustomLanguageSelect.vue";

export default Vue.extend({
	props: {
		value: Object as () => DocumentPageSettings
	},
	components: {
		AppLanguageSelect
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	},
});
